import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: rgba(245, 35, 35, 0.25);
`;

export const Text = styled.p`
  flex: 1 1 auto;
  font-size: var(--font-size13);
  font-weight: var(--font-weight600);
  line-height: 1.15;
  letter-spacing: 0.9px;
  color: var(--color-red);
  text-align: center;
`;

export const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
`;
